import { AfterViewInit, Directive, Optional } from "@angular/core";
import { NgControl } from "@angular/forms";
import { MatInput } from "@angular/material/input";
import { Logger } from "@dtm-frontend/shared/utils";

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: "[matInput]" })
export class AutoInputIdDirective implements AfterViewInit {
    constructor(@Optional() private input: MatInput, @Optional() private inputControl?: NgControl) {}

    public ngAfterViewInit() {
        if (!this.input) {
            Logger.captureException(new Error("Missing input provider for AutoInputIdDirective"));

            return;
        }

        const isCustomId = !this.input.id.startsWith("mat-input-");
        if (isCustomId) {
            return;
        }

        const controlName = this.getControlName() ?? this.input.id;
        this.input.id = `auto_${controlName}`;
    }

    private getControlName(): string | undefined {
        const inputControl = this.inputControl?.control;

        for (const [controlName, control] of Object.entries(inputControl?.parent?.controls ?? {})) {
            if (control === inputControl) {
                return controlName;
            }
        }

        return undefined;
    }
}
